import { TypeViagem } from "./Viagem"

export enum EnumStatusDaViagem {
    EM_ANDAMENTO = 1,
    ENCERRADA = 2,
    CANCELADA = 3,
}

export type TypeStatusDaViagem = {
    codigo?: EnumStatusDaViagem,
    descricao?: string,
    ativo?: boolean,
    viagens: TypeViagem[]
}
